import React from 'react'
import {Redirect} from 'react-router-dom'
import {Helmet} from 'react-helmet'
import './index.scss'
import CartBar from './CartBar'

// ── Baldwin Park Pizza Co. — ordering app (CRA) ──────────────────────────────
// Ordering surface ONLY. The marketing site (home / menu / catering / hours /
// contact) is a separate Astro deploy at the apex domain. This CRA is deployed
// standalone (e.g. ordering.baldwinparkpizzaco.com) and the marketing site's
// /order proxies/redirects here. Menu data loads from the POS by restaurantId
// "baldwin". See how-to-integrate-vite-site.md / the marketing repo's vercel.json.

// Paths on which the shared <AutoMenu> ordering view renders. We intentionally
// do NOT include "/" here: Default404NotFound opts out of /order and /menu but
// not "/", so rendering the menu on root would stack a 404 notice under it.
// Instead, "/" redirects to /order below.
export const customOrderAppPaths = ["/menu", "/order"]

// Sticky top bar shown across the ordering flow (menu / product / cart).
export {CartBar as StickyTopBar}

export const pages = [
  // Ordering host root → straight into the menu (avoids the root 404 notice).
  {path: "/", component: () => <Redirect to="/order" />},
  {path: "/order", label: "Order"},
  {path: "/menu", label: "Menu"},
]

export function SiteNav ({shopId}) {
  return (
    <Helmet>
      <title>Order Online — Baldwin Park Pizza Co.</title>
      <meta name="theme-color" content="#4a2f7a" />
    </Helmet>
  )
}
